//frontend/src/utils/assets.ts
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export function resolveAssetUrl(path?: string | null) {
  if (!path) return null;
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  // Ensure leading slash
  const normalized = path.startsWith("/")
    ? path
    : `/${path}`;

  return `${API_BASE_URL}${normalized}`;
}
